import { DockListURIParams } from '../models';

export class DockListLoad {
  public static readonly type = '[DockList] Load';
  constructor(public payload: DockListURIParams) {}
}

export class DockListEnableItem {
  public static readonly type = '[DockList] Enable Dock';
  constructor(
    public payload: {
      hubId: number;
      compartmentId: number;
      dockId: number;
      enable: boolean;
    },
  ) {}
}

export class DockListInitialState {
  public static readonly type = '[DockList] Set initial state';
}
